function addProtocol<T extends string | undefined>(url: T): T {
    return url ? (`https:${url}` as T) : url
}

export { addProtocol }
